import script from "./SuggestionChips.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionChips.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionChips.vue?vue&type=style&index=0&id=56c06a20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c06a20"]])

export default __exports__